if (!customElements.get('multicolumn-tabs')) {
  class MulticolumnTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          this.setActiveTab(Number(tab.dataset.index));
        });
      });

      this.querySelector('[role="tablist"]').addEventListener('keydown', (e) => {
        const current = Number(this.querySelector('[aria-selected="true"]').dataset.index);
        let next = current;
        if (e.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
        else if (e.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
        else return;
        e.preventDefault();
        this.setActiveTab(next);
        this.tabs[next].focus();
      });
    }

    setActiveTab(index) {
      this.tabs.forEach((tab) => {
        tab.setAttribute('aria-selected', 'false');
        tab.classList.remove('multicolumn-tabs__tab--active');
      });
      this.panels.forEach((panel) => panel.setAttribute('hidden', ''));

      this.tabs[index].setAttribute('aria-selected', 'true');
      this.tabs[index].classList.add('multicolumn-tabs__tab--active');
      this.panels[index].removeAttribute('hidden');
    }
  }

  customElements.define('multicolumn-tabs', MulticolumnTabs);
}
